module.exports = __webpack_public_path__ + "static/media/videocam-32px.fc4b7780.svg";